import { Shield, Award, Target, TrendingUp } from "lucide-react";

const GooglePartnerSection = () => {
  return (
    <section id="google-partner" className="py-16 bg-gradient-to-br from-blue-50 via-white to-green-50 border-y border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Başlık */}
        <div className="text-center mb-12">
          <div className="inline-block mb-4">
            <span className="px-4 py-2 bg-gradient-to-r from-blue-600 to-blue-700 text-white text-sm font-bold rounded-full shadow-lg">
              🏆 Sertifikalı Partner
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-4">
            <span className="text-[#059669]">Google Ads Partner Ajansları</span> İçinde Yer Alıyorum
          </h2>
          <p className="text-xl text-gray-700 max-w-4xl mx-auto leading-relaxed">
            <span className="font-bold text-[#059669]">Merhaba, Ben Dijital Mustafa</span>, 
            <span className="font-semibold"> Google Ads Partner Ajans</span> statümle 
            <span className="font-bold text-[#059669]"> Google Ads reklam verme</span> konusunda 
            uzman desteği sunuyorum.
          </p>
        </div>

        {/* Partner Badge ve Bilgi Kartları */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {/* Kart 1 */}
          <div className="bg-white rounded-2xl p-6 shadow-lg border-2 border-blue-200 hover:border-blue-500 hover:shadow-xl transition-all duration-300">
            <div className="flex justify-center mb-4">
              <div className="w-16 h-16 bg-gradient-to-br from-blue-600 to-blue-700 rounded-xl flex items-center justify-center shadow-lg">
                <Award className="w-8 h-8 text-white" />
              </div>
            </div>
            <h3 className="text-lg font-black text-gray-900 mb-2 text-center">
              Google Partner Sertifikası
            </h3>
            <p className="text-sm text-gray-700 leading-relaxed text-center">
              <span className="font-bold text-[#059669]">Google Partner Ajansları</span> içinde 
              yer alan <span className="font-semibold">Google Ads Uzmanı</span> olarak 
              sertifikalı hizmet garantisi sunuyorum.
            </p>
          </div>

          {/* Kart 2 */}
          <div className="bg-white rounded-2xl p-6 shadow-lg border-2 border-green-200 hover:border-green-500 hover:shadow-xl transition-all duration-300">
            <div className="flex justify-center mb-4">
              <div className="w-16 h-16 bg-gradient-to-br from-[#059669] to-[#047857] rounded-xl flex items-center justify-center shadow-lg">
                <Target className="w-8 h-8 text-white" />
              </div>
            </div>
            <h3 className="text-lg font-black text-gray-900 mb-2 text-center">
              Profesyonel Reklam Verme
            </h3>
            <p className="text-sm text-gray-700 leading-relaxed text-center">
              <span className="font-bold text-[#059669]">Google Ads reklam verme</span> 
              konusunda <span className="font-semibold">Google AdWords Uzmanı</span> olarak 
              kampanyalarınızı bizzat ben yönetiyorum.
            </p>
          </div>

          {/* Kart 3 */}
          <div className="bg-white rounded-2xl p-6 shadow-lg border-2 border-red-200 hover:border-red-500 hover:shadow-xl transition-all duration-300">
            <div className="flex justify-center mb-4">
              <div className="w-16 h-16 bg-gradient-to-br from-red-600 to-red-700 rounded-xl flex items-center justify-center shadow-lg">
                <Shield className="w-8 h-8 text-white" />
              </div>
            </div>
            <h3 className="text-lg font-black text-gray-900 mb-2 text-center">
              Sahte Tıklama Koruması
            </h3>
            <p className="text-sm text-gray-700 leading-relaxed text-center">
              <span className="font-bold text-[#059669]">Google Ads sahte tıklama engelleme</span> 
              sistemiyle bütçenizi koruyorum, <span className="font-semibold">Google Reklam Uzmanı</span> 
              olarak %80'e varan koruma sağlıyorum.
            </p>
          </div>

          {/* Kart 4 */}
          <div className="bg-white rounded-2xl p-6 shadow-lg border-2 border-purple-200 hover:border-purple-500 hover:shadow-xl transition-all duration-300">
            <div className="flex justify-center mb-4">
              <div className="w-16 h-16 bg-gradient-to-br from-purple-600 to-purple-700 rounded-xl flex items-center justify-center shadow-lg">
                <TrendingUp className="w-8 h-8 text-white" />
              </div>
            </div>
            <h3 className="text-lg font-black text-gray-900 mb-2 text-center">
              Tüm Platform Desteği
            </h3>
            <p className="text-sm text-gray-700 leading-relaxed text-center">
              <span className="font-bold text-[#059669]">Google Haritalarda reklam verme</span>, 
              YouTube, Display Network dahil tüm platformlarda 
              <span className="font-semibold"> Google Ajansı</span> hizmetleri.
            </p>
          </div>
        </div>

        {/* Alt Bilgi */}
        <div className="mt-12 text-center">
          <div className="bg-gradient-to-r from-blue-600/10 via-green-600/10 to-blue-600/10 rounded-2xl p-8 border-2 border-blue-300">
            <p className="text-lg text-gray-900 leading-relaxed max-w-4xl mx-auto">
              <span className="font-black text-[#059669]">Ben Dijital Mustafa</span>, 
              <span className="font-bold text-gray-900"> Google Reklam Ajansı</span> statüm sayesinde 
              <span className="font-bold text-[#059669]"> Google Ads reklam verme</span> konusunda özel destek ve 
              erken erişim avantajlarına sahibim. <span className="font-semibold">Google Ads Reklam Uzmanı</span> 
              olarak işletmenizi bizzat ben zirveye taşıyorum.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GooglePartnerSection;
